import {
  VuexModule,
  getModule,
  Module,
  MutationAction
} from 'vuex-module-decorators';
import store from '@/store';
import { Route } from 'vue-router';

@Module({ namespaced: true, name: 'menu', store, dynamic: true })
export class MenuModule extends VuexModule {
  public isShowMenu: boolean | null = null;
  public isShowLoading: boolean | null = null;
  public previousRoute: Route | null = null;

  @MutationAction
  async updateMenuStatus(isShowMenu: boolean) {
    return { isShowMenu };
  }

  @MutationAction
  async updateLoading(isShowLoading: boolean) {
    return { isShowLoading };
  }

  @MutationAction
  async updatePreviousPath(previousRoute: Route) {
    return { previousRoute };
  }
}

const menuModule = getModule(MenuModule);
export default menuModule;
